import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCommonColumns } from "../../../../utils/hooks/useCommonColumns";
import { useIsMasterCompany } from "../../../../utils/hooks/company";
import { createColumnHelper } from "@tanstack/react-table";
import Select from "../../../../components/Inputs/Select";

const columnHelper = createColumnHelper();

export const useColumns = ({ edit, remove, clone }) => {
	const { t } = useTranslation();
	const isMasterCompany = useIsMasterCompany();

	const { code, description, status, actions } = useCommonColumns({ edit, remove, clone });

	return useMemo(() => {
		const columns = [
			code,
			description,
			status,
			columnHelper.accessor("display", {
				enableColumnFilter: true,
				header: t("display"),
				cell: (info) => {
					const value = info.getValue();
					return value ? t(value) : null;
				},
				filterType: "select",
				Filter: (
					<Select className="form-control-sm p-0" showSearch>
						{[
							"code", 
							"description", 
							"code-description", 
							"gl-segment",
							"glSegment-description"
						].map((option) => (
							<Select.Option key={option} value={option}>
								{t(option)}
							</Select.Option>
						))}
					</Select>
				),
			}),
			columnHelper.accessor("isRequired", {
				header: t("is-required"),
				cell: (info) => info.getValue() ? t("yes") : t("no"),
			}),
			columnHelper.accessor("allocatedBy", {
				header: t("allocated-by"),
				cell: (info) => info.getValue() ? t("yes") : t("no"),
			}),
			columnHelper.accessor("hasBudget", {
				header: t("has-budget"),
				cell: (info) => info.getValue() ? t("yes") : t("no"),
			}),
			columnHelper.accessor("hasHierarchy", {
				header: t("has-hierarchy"),
				cell: (info) => info.getValue() ? t("yes") : t("no"),
			}),
			columnHelper.accessor("useInClockIn", {
				header: t("use-in-clock-in"),
				cell: (info) => info.getValue() ? t("yes") : t("no"),
			}),
			columnHelper.accessor("inclueLocationHierarchy", {
				header: t("location-hierarchy"),
				cell: (info) => info.getValue() ? t("yes") : t("no"),
			}),
		];
		if (isMasterCompany && actions) {
			columns.push(actions);
		}
		return columns;
	}, [t, isMasterCompany, code, description, status, actions]);
};
